import $ from "jquery";
import anime from "animejs";
import queryString from "query-string";
import Cookies from "js-cookie";

import { setAllLikes } from "./helper";

$(document).on("click tap", "[data-like]", function (e) {
    e.preventDefault();
    e.stopPropagation();
    let potentiallyOpenOverlay = false;
    let event = "favorite_trip";

    // Unlike
    if ($(this).hasClass("s_is-liked")) {
        event = "unfavorite_trip";
        $(this).removeClass("s_is-liked");
    } else {
        // Like
        potentiallyOpenOverlay = true;
        $(this).addClass("s_is-liked");
    }

    let trackingProps;

    try {
        trackingProps = JSON.parse($(this).attr("data-tracking-props"));
    } catch (e) {}

    if (trackingProps) {
        // Tracking
        window.dataLayer = window.dataLayer || [];
        const data = {
            event,
            destination: trackingProps.destination,
            destination_id: trackingProps.destinationId,
            trip: trackingProps.trip,
            trip_id: trackingProps.tripId,
            price: parseInt(trackingProps.price, 10),
            number_of_days: parseInt(trackingProps.numberOfDays, 10),
        };

        // On click favorite
        window.dataLayer.push(data);
    }

    var like = $(this).attr("data-like");

    $(".sb_menu-main_btn-likes").addClass("s_has-likes");

    // Check if cookie exists
    if (Cookies.get("sb-likes")) {
        var likes = JSON.parse(Cookies.get("sb-likes"));

        if (likes.includes(like)) {
            // If like already exists in the array, remove it
            likes = likes.filter(function (item) {
                return item !== like;
            });
        } else {
            // If like does not exist, append it
            likes.push(like);
        }

        $(".sb_menu-main_btn-likes_amount").html(likes.length);

        var tl = anime.timeline({
            duration: 200,
        });

        tl.add({
            targets: ".sb_menu-main_btn-likes_amount",
            easing: "easeOutExpo",
            scale: [1, 1.6],
        }).add({
            targets: ".sb_menu-main_btn-likes_amount",
            easing: "easeOutExpo",
            scale: [1.6, 1],
        });

        Cookies.set("sb-likes", JSON.stringify(likes), {
            expires: 60,
            secure: true,
        });

        if (likes.length > 3 && potentiallyOpenOverlay) {
            $("[data-open-likes-overlay]").trigger("click");
        }
    } else {
        Cookies.set("sb-likes", JSON.stringify([like]), {
            expires: 60,
            secure: true,
        });
    }

    setAllLikes();
});

setAllLikes();

/**
 * Get template likes content
 */
$(document).on("click tap", "[data-open-likes-overlay]", function (e) {
    const likes = {
        likes: JSON.parse(Cookies.get("sb-likes") || JSON.stringify([])),
    };
    const viewed = {
        viewed: JSON.parse(
            Cookies.get("sb-viewed-templates") || JSON.stringify([])
        ),
    };
    const qs = queryString.stringify(
        { ...likes, ...viewed },
        { arrayFormat: "bracket" }
    );

    $("body").addClass("s_is-open_side-panel");

    const template_likes_url = `${HOME_URL}/get-template-likes/?${qs}`;

    console.log(template_likes_url);

    $.get(template_likes_url, function (data) {
        const content = JSON.parse(data);

        $("#side-panel").append(content[0].slot);
    });
});

/**
 * Clear viewed templates
 *
 */
$(document).on("click tap", "[data-clear-viewed-templates]", function (e) {
    e.preventDefault();
    e.stopPropagation();
    Cookies.remove("sb-viewed-templates");

    // Clear items and show no result text
    $("#viewed-templates").html("").addClass("s_is-hidden");
    $(".sb_templates-likes_items_no-result").removeClass("s_is-hidden");

    $(".sb_menu-main_btn-likes").removeClass("s_has-recents");
});
